const StockFormFields = ({ form, updateField }) => {
  return (
    <>
      <input value={form.scrip} onChange={(e) => updateField("scrip", e.target.value.toUpperCase())} />

<input
  type="date"
  value={form.date}
  onChange={(e) => updateField("date", e.target.value)}
  max={new Date().toISOString().split("T")[0]}   // ✅ blocks future dates
  required
/>
      <input type="number" value={form.rate} onChange={(e) => updateField("rate", e.target.value)} required />

      <input type="number" value={form.quantity} onChange={(e) => updateField("quantity", e.target.value)} required/>

      <select value={form.transactionType} onChange={(e) => updateField("transactionType", e.target.value)} required>
        <option value="BUY">Buy</option>
        <option value="SELL">Sell</option>
      </select>

      <input
  type="number"
  placeholder="Amount"
  value={form.amount}
  onChange={(e) => updateField("amount", e.target.value)}
  required
/>
    </>
  );
};

export default StockFormFields;